<template>
    <Feed v-if="$store.state.signedIn"></Feed>
    <Splash v-else></Splash>
</template>

<script>
    import helpers from "@/helpers";
    import Feed from '@/views/Feed.vue';
    import Splash from '@/views/Splash.vue';

    export default {
        name: "Main",
        components: {
            Feed,
            Splash
        },
        async beforeMount() {
            try {
                const user = await this.$Amplify.Auth.currentAuthenticatedUser();
                const userDetails = helpers.getUserDetails(user);
                // bloody cognito... nasty checks
                if (!('custom:fromCityId' in userDetails)) {
                    this.$Amplify.Auth.userAttributes(this.$store.state.user).then(res => {
                        // has gone through the initial setup
                        const found = res.find(function (element) {
                            return (element['Name'] == 'custom:fromCityId')
                        });
                        if (!found) {
                            this.$router.push('/location');
                        }
                    }).catch(err => {
                        this.$logger.error(err);
                    });
                }
            } catch(e) {
                this.$logger.error(e);
            }
        }
    }
</script>

<style scoped>

</style>